import BasePage from '../../../../../components/table_page';

export default {
  name: 'banquet_reward_details',
  extends: BasePage,
  data() {
    return {};
  },
  components: {},
  created() {
    this.getConfigList('main_list');
  },
  methods: {},
};
